module.exports = __webpack_public_path__ + "static/media/icon-list-sparse.623e35db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-list-sparse.svg
// module id = 1853
// module chunks = 0